module.exports = __webpack_public_path__ + "static/media/RecomendaCopacabana.61b43438.jpg";